import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { AreaListOfSearchModal } from '@doda/common/src/models/MasterCacheModel';
import { NATIONAL_AREA_NUMBER } from '@doda/common/src/constants/properties/const';

/**
 * エリアのAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @param areas エリアのマスタ
 * @returns エリアのAPIリクエスト
 */
export const createAreasApiRequest = (
  queryParams: AppQueryParams,
  areas: AreaListOfSearchModal[] | null
) => {
  let areaName = '';
  let ar = '';
  let requestAreaId: string[] | undefined = [];

  if (queryParams.ar) [ar] = queryParams.ar;
  const findAr = areas?.find((area) => area.id === ar);
  if (ar === NATIONAL_AREA_NUMBER) {
    // 全国は求人コンテンツの表示対象外
    throw new Error('求人コンテンツ表示対象外のパラメータ(ar)');
  }
  if (findAr) {
    areaName = findAr.name;
    requestAreaId = queryParams.ar;
  } else {
    // マスタに存在しない不正な値
    throw new Error('パラメータの不正(ar)');
  }

  return { areaName, requestAreaId };
};
